/*
 * Chart themes — the named line/gradient palettes a user picks from.
 *
 * These are real colour strings rather than var(--token) because charts render
 * to Canvas, which resolves no custom properties: a gradient stop has to be a
 * literal at the point it is handed to the 2D context. That makes this the one
 * palette in the system that cannot live in tokens.css, so it lives here
 * instead — still declared once, in base-ui, rather than copied into each app.
 *
 * Deliberately independent of the app accents. A chart's job is to separate
 * series legibly, so these are chosen for mutual contrast; --blue and friends
 * are chosen to sit quietly behind UI. Pinning one to the other would mean a
 * change to either fights the other's purpose.
 */
export const CHART_THEMES = {
    blue: { line: '#1a8cd8', gradient: ['#0f6db8', '#5db8f0'] },
    frost: { line: '#1a8cd8', gradient: ['#0f6db8', '#5db8f0'] },
    // Citrus is the YELLOW theme — keep BOTH gradient stops in the bright-yellow
    // band (no amber/golden) so the preview never reads as peach's amber→red.
    citrus: { line: '#facc15', gradient: ['#fef08a', '#facc15'] },
    candy: { line: '#e54590', gradient: ['#e54590', '#a855f7'] },
    mint: { line: '#10b981', gradient: ['#074730', '#34d399'] },
    berry: { line: '#8b5cf6', gradient: ['#8b5cf6', '#ec4899'] },
    peach: { line: '#fb923c', gradient: ['#fbbf24', '#f87171'] },
};
/** Order shown in the picker — frost (the default) first. */
export const CHART_THEME_NAMES = [
    'frost', 'peach', 'citrus', 'candy', 'mint', 'berry', 'blue',
];
export const SELECTABLE_CHART_THEMES = [
    'frost', 'peach', 'citrus', 'candy', 'mint', 'berry',
];
//# sourceMappingURL=chart-themes.js.map